import React, {
    useCallback, useEffect
} from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import { PremierConstants } from 'premier-constant-service';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import AddlInterestTextBoxComponent from "../../components/AddlInterestTextBoxComponent/AddlInterestTextBoxComponent";
import metadata from './LiabilityCoveragesPage.metadata.json5';
import messages from './LiabilityCoveragesPage.messages.js';
import styles from './LiabilityCoveragesPage.module.scss';

import CoveragesPageComponent from "../Coverages/CoveragesPage";

function LiabilityCoveragesPage(props) {

    const { wizardData: submissionVM, updateWizardData } = props;

    const {
        onValidate,
        initialValidation
    } = useValidation('LiabilityCoveragesPage');
    const { lineName } = PremierConstants;
    const { updateSubmission } = useUpdateSubmissionServices();

    const onNext = useCallback(
        async () => {

            const { productCode } = submissionVM.value.baseData;
            const lobLineName = lineName[productCode];

            submissionVM.value = await updateSubmission(lobLineName, 'PropertyCoveragesPage', submissionVM);

            return submissionVM;
        },
        [lineName, submissionVM, updateSubmission]
    );

    const onSave = useCallback(
        async () => {
            const subVMCopy = _.clone(submissionVM)
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');

            validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.eveLiaLine.coverables.additionalInterests.value, ' ')

            const lobLineName = productCode ? lineName[productCode] : '';
            await updateSubmission(lobLineName, 'LiabilityCoveragesPage', subVMCopy);
                            
            return submissionVM;
        },
        [lineName, submissionVM, updateSubmission]
    );

    useEffect(() => {

    }, []);

    const overrideProps = {
        pleLineCoverageComponent: {
            wizardData: submissionVM,
            updateWizardData,
            clausesBasePath: `lobData.eveLiaLine.lineCoverages.coverages`,
            title: messages.covMiscellaneous,
            clasueType: 'coverages',
            pathToGet: 'eveLiaLine.coverages'
        },
        additionalInterest:{
            wizardData: submissionVM,
            updateWizardData,
            addlIntPath: 'lobData.eveLiaLine.coverables.additionalInterests',
            isLineLevel: true
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            coveragespagecomponent: CoveragesPageComponent,
            AddlInterestTextBoxComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [metadata, submissionVM, overrideProps]
    );


    const isDisableNext = () => _.find(submissionVM.value.lobData.eveLiaLine.lineCoverages.coverages, { isValid: false })
        || !_.get(submissionVM, 'lobData.eveLiaLine.coverables.additionalInterests.aspects.subtreeValid')

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

LiabilityCoveragesPage.propTypes = wizardProps;
export default withRouter(LiabilityCoveragesPage);
